var render = function render(){var _vm=this,_c=_vm._self._c;return _c('site-events',{attrs:{"tabs":_vm.allTabs,"events":_vm.currentItems(),"event-signal-by-id":_vm.eventSignalById,"pages":_vm.eventsPages,"count":_vm.currentCount()},on:{"refresh-request":_vm.handleRefresh,"download-request":_vm.downloadEvents}})
}
var staticRenderFns = []

export { render, staticRenderFns }